import { Button, Notification, Text } from '@flixbus/honeycomb-react';

import { appUpdateText } from './text';
import { useAppUpdate } from './useAppUpdate';

import styles from './styles.module.css';

const AppUpdatePrompt = () => {
	const { hasUpdate, reloadApp, dismissUpdate } = useAppUpdate();

	if (!hasUpdate) return null;

	return (
		<Notification
			extraClasses={styles.container}
			closeProps={{ 'aria-label': 'Close', onClick: dismissUpdate }}
		>
			<Text>{appUpdateText.message}</Text>
			<Button type="button" appearance="primary" onClick={reloadApp}>
				{appUpdateText.updateButton}
			</Button>
		</Notification>
	);
};

export default AppUpdatePrompt;
